import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

const CoronaVirusBanner = loadable(
    () => import('../../../../components/Banners'),
    {
        resolveComponent: (components) => components.CoronaVirusBanner,
    },
);
const VaccineBanner = loadable(() => import('../../../../components/Banners'), {
    resolveComponent: (components) => components.VaccineBanner,
});
const VotingBanner = loadable(() => import('../../../../components/Banners'), {
    resolveComponent: (components) => components.VotingBanner,
});
const SiteMaintenanceBanner = loadable(
    () => import('../../../../components/Banners'),
    {
        resolveComponent: (components) => components.SiteMaintenanceBanner,
    },
);
const PlaybookBanner = loadable(
    () => import('../../../../components/Banners'),
    {
        resolveComponent: (components) => components.PlaybookBanner,
    },
);

// Logic for the special banners we put up sometimes
// The banner itself
const specialBanner = VotingBanner;

// The domains where the banner should be visible, leave the array as [''] for ALL Tlds
const specialBannerDomains = ['.com'];

// Checks if we are within the timeframe of the banner
const isSpecialBannerTimeFrame = () => {
    // To show the banner simultaneusly on many different TLDs at the EXACT same time, use UTC time like here https://github.com/eventbrite/eb-ui/pull/9301
    const today = new Date();

    // Edit these dates with the new ones once a new banner is requested, months are 0-indexed
    // Remember to put the day after the actual end of the banner
    const specialBannerDateStart = new Date(2021, 8, 24);
    const specialBannerDateEnd = new Date(2021, 8, 29);

    const startDate = today >= specialBannerDateStart;
    const endDate = today <= specialBannerDateEnd;
    return startDate && endDate;
};

export const verifyDomain = (domain) => {
    if (isSpecialBannerTimeFrame()) {
        let isSpecialDomain = false;

        specialBannerDomains.forEach((specialDomain) => {
            if (domain.endsWith(specialDomain)) {
                isSpecialDomain = true;
            }
        });

        return isSpecialDomain;
    } else {
        return domain.endsWith('.com');
    }
};

const SEARCH_TRACKING_PARAM =
    'utm_source=eventbrite&utm_medium=banner&utm_campaign=search';
const HOME_TRACKING_PARAM =
    'utm_source=eventbrite&utm_medium=banner&utm_campaign=home';

const shouldBannerRender = (props) => {
    if (verifyDomain(props.domain)) {
        return true;
    }

    return false;
};

const getCategory = (isSearch, isAuthenticated) => {
    if (isSearch) {
        return 'search';
    }

    if (isAuthenticated) {
        return 'home-feed';
    }

    return 'home';
};

const getBanner = (isSearch) => {
    if (isSpecialBannerTimeFrame()) {
        return { Banner: isSearch ? null : specialBanner };
    }
    return { Banner: isSearch ? null : PlaybookBanner };
};

const USBanner = (props) => {
    const shouldRender = shouldBannerRender(props);

    if (!shouldRender) {
        return <CoronaVirusBanner />;
    } else {
        const category = getCategory(props.isSearch, props.isAuthenticated);
        const trackingParams = props.isSearch
            ? SEARCH_TRACKING_PARAM
            : HOME_TRACKING_PARAM;

        const { Banner, version } = getBanner(props.isSearch);

        if (!Banner) {
            return null;
        }

        return (
            <Banner
                version={version}
                category={category}
                trackingParams={trackingParams}
                handleTracking={props.handleTracking}
            />
        );
    }
};

USBanner.propTypes = {
    isSearch: PropTypes.bool,
    handleTracking: PropTypes.func,
    isAuthenticated: PropTypes.bool,
};

const _mapStateToProps = (state) => ({
    domain: state.app.domain,
    isAuthenticated: state.auth
        ? state.auth.isAuthenticated
        : state.user.isAuthenticated,
});

const _mapDispatchToProps = (dispatch) => ({
    handleTracking: (...args) => dispatch(...args),
});

export default connect(_mapStateToProps, _mapDispatchToProps)(USBanner);
